import Vue from 'vue';
import 'sweetalert/dist/sweetalert.css';
import html from '../templates/visual-editor-stamps-list.html';
import '../assets/css/visual-editor-stamps-list.css';

export default Vue.component('visual-stamps-list', {
  template: html,
  props: ['story', 'hostUrl', 'stampIndex', 'storyId'],
  data() {
    return {
      positions: {
        frame: [{name: 'bottom', value: 'b'}, {name: 'top', value: 't'}],
        static: [
          {
            name: 'top left',
            value: 'tl'
          },
          {
            name: 'top center',
            value: 'tc'
          },
          {
            name: 'top right',
            value: 'tr'
          },
          {
            name: 'middle left',
            value: 'ml'
          },
          {
            name: 'middle center',
            value: 'mc'
          },
          {
            name: 'middle right',
            value: 'mr'
          },
          {
            name: 'bottom left',
            value: 'bl'
          },
          {
            name: 'bottom center',
            value: 'bc'
          },
          {
            name: 'bottom right',
            value: 'br'
          }
        ],
        eyes: [],
        mouth: []
      },
      stampTypes: ['eyes', 'mouth', 'static', 'frame']
    };
  },
  methods: {
    // Send changed story or stamp index
    typeChanges(story, index, type, currStamp) {
      let changedTypeStamp = {};
      if (type === 'static') {
        story.data.content[index].points[0] = {x: 0, y: 0};
        story.data.content[index].position = 'tl';
        story.data.content[index].scale = 1;
        story.data.content[index].rotation = 0;
      } else {
        // mean type frame
        story.data.content[index].points[0] = {x: 60, y: 0};
        story.data.content[index].position = 't';
      }
      changedTypeStamp = Object.assign(changedTypeStamp, story.data.content[index]);
      this.$emit('story-update', story);
      this.$emit('type-trigger', changedTypeStamp);
      this.$emit('stamp-index', index);
      console.log('changedTypeStamp ', changedTypeStamp);
      // console.warn('type ', type);
    },
    // Delete stmap function
    deleteStamp(pivotId, stamp) {
      console.log('delete stamp function');
      let that = this;
      let loader = document.getElementsByClassName('loader')[0];
      let stampIndex = that.story.data.content.indexOf(stamp);
      loader.style.display = 'block';
      let deleteState = confirm('Do you want to delete this stamp?');
      if (deleteState) {
        that.story.data.content.splice(stampIndex, 1);
        that.$http.delete(`${that.hostUrl}/cp/stories/${that.storyId}/content/${pivotId}`).then((success) => {
          console.log('success ', success);
          loader.style.display = 'none';
          this.$emit('delete', that.story, stamp);
        }, (error) => {
          console.warn('error ', error);
          loader.style.display = 'none';
        });
      } else {
        loader.style.display = 'none';
      }
    },
    emitFramePosition(position) {
      console.warn(this.currentStamp.position);
      console.warn(position);
      this.$emit('frame-position');
    },
    backspaceDeleteButton(e) {
      let that = this;
      if (e.keyCode === 8 || e.keyCode === 46) {
        that.deleteStamp(that.currentStamp.pivot_id, that.currentStamp);
      }
    }
  },
  computed: {
    // a computed currentStamp
    currentStamp() {
      // console.log('currStampObj ', this.story.data.content[this.stampIndex]);
      return this.story.data.content[this.stampIndex];
    },
    currentScale() {
      // console.log('curr stamp ', this.story.data.content[this.stampIndex]);
      return this.story.data.content[this.stampIndex].scale.toFixed(2);
    }
  },
  mounted() {
    window.addEventListener('keyup', this.backspaceDeleteButton);
  },
  destroyed() {
    window.removeEventListener('keyup', this.backspaceDeleteButton);
  }
});



// WEBPACK FOOTER //
// ./src/js/visual-editor-stamps-list-component.js